var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagStVincentAndTheGrenadines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6517 1.95716C21.3786 0.716906 18.7714 0.0117188 15.9996 0.0117188C13.2277 0.0117188 10.6206 0.716906 8.34737 1.95716L6.95605 16.0117L8.34737 30.0663C10.6206 31.3065 13.2277 32.0117 15.9996 32.0117C18.7714 32.0117 21.3786 31.3065 23.6517 30.0663L25.0431 16.0117L23.6517 1.95716Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34781 30.0661V1.95703C3.37431 4.67078 0 9.94697 0 16.0117C0 22.0763 3.37431 27.3525 8.34781 30.0661Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0117C32 9.94697 28.6257 4.67078 23.6522 1.95703V30.0661C28.6257 27.3525 32 22.0763 32 16.0117Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5218 20.1858L9.73907 16.0118L12.5217 11.8379L15.3045 16.0118L12.5218 20.1858Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4787 20.1858L16.6961 16.0118L19.4787 11.8379L22.2614 16.0118L19.4787 20.1858Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 25.7506L13.2174 21.5767L16 17.4028L18.7826 21.5767L16 25.7506Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagStVincentAndTheGrenadines);
export default __webpack_public_path__ + "static/media/flag_st_vincent_and_the_grenadines.e2b5dab076a4751febec921d2ea4637d.svg";
export { ForwardRef as ReactComponent };